import { render, staticRenderFns } from "./AddModify.vue?vue&type=template&id=54099631"
import script from "./AddModify.vue?vue&type=script&lang=js"
export * from "./AddModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports